export const getConcernByNameOrIndex = (items, name, fallbackIndex) => {
  if (!Array.isArray(items)) {
    return undefined;
  }

  const byName = items.find((item) => item?.name === name);
  if (byName) {
    return byName;
  }

  if (
    Number.isInteger(fallbackIndex) &&
    fallbackIndex >= 0 &&
    fallbackIndex < items.length
  ) {
    return items[fallbackIndex];
  }

  return undefined;
};

export const getConcernFieldByNameOrIndex = (
  items,
  name,
  fallbackIndex,
  field
) => {
  const concern = getConcernByNameOrIndex(items, name, fallbackIndex);
  return concern ? concern[field] : undefined;
};

export const patchSurveyDataArrayItem = ({
  data,
  arrayKey,
  name,
  fallbackIndex,
  patch,
}) => {
  const baseData = data ? { ...data } : {};
  const sourceArray = Array.isArray(baseData[arrayKey]) ? baseData[arrayKey] : [];

  if (!sourceArray.length) {
    return baseData;
  }

  const nextArray = sourceArray.map((item) => ({ ...item }));
  let targetIndex = nextArray.findIndex((item) => item?.name === name);

  if (
    targetIndex === -1 &&
    Number.isInteger(fallbackIndex) &&
    fallbackIndex >= 0 &&
    fallbackIndex < nextArray.length
  ) {
    targetIndex = fallbackIndex;
  }

  if (targetIndex === -1) {
    return baseData;
  }

  nextArray[targetIndex] = {
    ...nextArray[targetIndex],
    ...(patch || {}),
  };

  return {
    ...baseData,
    [arrayKey]: nextArray,
  };
};
